import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { firstValueFrom } from 'rxjs';

import { AuthenticationService } from './authentication.service';
import { Response, UserTopup } from '../interfaces';
import { environment } from '../../environments/environment';

interface PaymentMethod {
  amount: number;
  currency: string;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private http = inject(HttpClient);
  private authenticate = inject(AuthenticationService);

  getPaymentMethods({ amount, currency }: PaymentMethod): Promise<Response> {
    const headers = this.authenticate.getHeaders();
    return firstValueFrom(this.http.post<Response>(`${environment.baseurl.api}/card/payment/method`, {
      amount,
      currency
    }, headers));
  }

  makePayment(data): Promise<Response> {
    return firstValueFrom(this.http.post<Response>(`${environment.baseurl.api}/card/payment`, data));
  }

  makeDetailsCall(data): Promise<Response> {
    return firstValueFrom(this.http.post<Response>(`${environment.baseurl.api}/card/payment/details`, data));
  }

  calculateWalletSum(all: UserTopup[]): number {
    // be aware of the topup transaction status
    let sum = 0;
    all.forEach((item: UserTopup) => sum += item.amount);
    return sum;
  }

  addPaymentLog(data): Promise<Response> {
    return firstValueFrom(this.http.post<Response>(`${environment.baseurl.api}/websdk/payment/logs`, data));
  }

  getActivePaymentIntigration(): Promise<Response> {
    return firstValueFrom(this.http.get<Response>(`${environment.baseurl.api}/payment/active-payment-intigration`, this.authenticate.getHeaders()));
  }

  getCaiboPaymentMethods(): Promise<Response> {
    return firstValueFrom(this.http.get<Response>(`${environment.baseurl.api}/payment/caibo/payment-methods`, this.authenticate.getHeaders()));
  }

  initiateCaiboPayment(payload: any): Promise<Response> {
    return firstValueFrom(this.http.post<Response>(`${environment.baseurl.api}/payment/caibo/initiate-payment`, {
      payload
    }, this.authenticate.getHeaders()));
  }

  getGPayScript(): Promise<string> {
    return firstValueFrom(
      this.http.get(`${environment.baseurl.api}/payment/caibo/gpay-script`, {
        responseType: 'text',
        ...this.authenticate.getHeaders()
      })
    );
  }

  getApplePayScript(): Promise<string> {
    return firstValueFrom(
      this.http.get(`${environment.baseurl.api}/payment/caibo/applepay-script`, {
        responseType: 'text',
        ...this.authenticate.getHeaders()
      })
    );
  }

  // Wallet
  getWalletConfigs(): Promise<Response> {
    return firstValueFrom(this.http.get<Response>(`${environment.baseurl.api}/payment/wallet/config`, this.authenticate.getHeaders()));
  }

  createPayment(payload: any): Promise<Response> {
    return firstValueFrom(this.http.post<Response>(`${environment.baseurl.api}/payment/wallet/create-payment`, {payload}, this.authenticate.getHeaders()));
  }

  getAppleSession(paymentId: string, domain: string): Promise<Response> {
    return firstValueFrom(this.http.get<Response>(`${environment.baseurl.api}/payment/wallet/apple-session/${paymentId}?domain=${domain}`, this.authenticate.getHeaders()));
  }

  processApplePayment(paymentId: string, paymentData: any): Promise<Response | any> {
    return firstValueFrom(this.http.get<Response>(`${environment.baseurl.api}/payment/wallet/process-apple/${paymentId}`, this.authenticate.getHeaders()));
  }

  processGooglePayment(paymentId: number | null, payload: any): Promise<Response> {
    console.log("Payment service 99::: paymentId-",paymentId,"payload-",payload)
    return firstValueFrom(this.http.post<Response>(`${environment.baseurl.api}/payment/wallet/process-google/${paymentId}`, payload, this.authenticate.getHeaders()));
  }

}
